import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { Cardholder, type CardholderConstructor } from './Cardholder'
import { IssuingProviders } from '../enums/IssuingProvider'

export const CardholderConstructorFactory =
  Factory.Sync.makeFactory<CardholderConstructor>({
    id: Factory.each(() => faker.random.number()),
    externalId: Factory.each(() => faker.random.uuid()),
    userId: Factory.each(() => faker.random.number()),
    email: Factory.each(() => faker.internet.email()),
    firstName: Factory.each(() => faker.name.firstName()),
    lastName: Factory.each(() => faker.name.lastName()),
    profileImage: Factory.each(() => faker.image.avatar()),
    tosAccepted: true,
    secondaryCategoryId: Factory.each(() => faker.random.number()),
    provider: Factory.each(() =>
      faker.random.arrayElement([
        IssuingProviders.STRIPE,
        IssuingProviders.AIRWALLEX,
      ])
    ),
  })

export const CardholderFactory = EntityFactory(
  Cardholder,
  CardholderConstructorFactory
)
